import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { StudentRatingState } from '../../../../features/types'
import { tableStyles, ui } from '../../../../utils/uiTokens'
import { useHeadIndex } from '../../../head/headData'
import { TotalScore, levelRowSx } from './RatingTable'

// Пән басшы: рейтинг, сведённый по менторам (средние по их ученикам)
const MentorRatingTable: React.FC<{ students: StudentRatingState[] }> = ({ students }) => {
    const { formatMessage } = useIntl()
    const index = useHeadIndex()

    const rows = index.mentors
        .map((m) => {
            const recs = students.filter((s) => s.groupId && m.groupIds.includes(s.groupId))
            const avg = (pick: (s: StudentRatingState) => number) =>
                recs.length ? Math.round(recs.reduce((sum, s) => sum + (pick(s) || 0), 0) / recs.length) : 0
            return {
                mentorId: m.mentorId,
                name: m.name,
                groups: m.groupIds.map((id) => index.groupTitle.get(id)).filter(Boolean).join(', '),
                count: recs.length,
                total: avg((s) => s.totalPoint),
                max: avg((s) => s.maxPoint),
                video: avg((s) => s.videoPoint),
                test: avg((s) => s.testPoint),
                zachet: avg((s) => s.zachetPoint),
                practice: avg((s) => s.practicePoint),
            }
        })
        .filter((r) => r.count > 0)
        .sort((a, b) => (b.max ? b.total / b.max : 0) - (a.max ? a.total / a.max : 0))

    return (
        <TableContainer component={Paper} sx={tableStyles.container} elevation={0}>
            <Table>
                <TableHead sx={tableStyles.head}>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>{formatMessage({ id: 'headGroupMentor' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'colStudents' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'headAvgPoint' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'video' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'test' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'zachet' })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: 'practice' })}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((r, i) => (
                        <TableRow key={r.mentorId} sx={{ ...tableStyles.row, ...levelRowSx(r.total, r.max) }}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>
                                <Box sx={{ fontWeight: 600 }}>{r.name}</Box>
                                <Box sx={{ fontSize: '12px', color: ui.muted }}>{r.groups}</Box>
                            </TableCell>
                            <TableCell align="center">{r.count}</TableCell>
                            <TableCell align="center"><TotalScore total={r.total} max={r.max} /></TableCell>
                            <TableCell align="center">{r.video}</TableCell>
                            <TableCell align="center">{r.test}</TableCell>
                            <TableCell align="center">{r.zachet}</TableCell>
                            <TableCell align="center">{r.practice}</TableCell>
                        </TableRow>
                    ))}
                    {rows.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={8} align="center">{formatMessage({ id: 'noData' })}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default MentorRatingTable
